var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8450 8450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1192e8",
    d: "M1974 5196l2020 1468v1482A3920 3920 0 01569 5648l1406-452zm4502 0l1406 452a3925 3925 0 01-3425 2498V6664l2020-1468z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#009d9a",
    d: "M1742 1190l867 1198-767 2362-1415 455a3930 3930 0 01-122-913l-1-65c0-1224 560-2317 1438-3037zm4966 0a3917 3917 0 011315 4015l-1415-455-766-2360 867-1198z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#42be65",
    d: "M4225 304a3900 3900 0 012108 615l-871 1201H2987L2117 918a3900 3900 0 012043-614l65-1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServo);
export default __webpack_public_path__ + "static/media/servo.6a62097672674c289623ff88a925abb0.svg";
export { ForwardRef as ReactComponent };